import { render, staticRenderFns } from "./CooperationList.vue?vue&type=template&id=19c5d49f&scoped=true&"
import script from "./CooperationList.vue?vue&type=script&lang=js&"
export * from "./CooperationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5d49f",
  null
  
)

export default component.exports